import { ReactElement } from 'react';
import RiskAndSupportDetails from '@components/FVSPage/RiskAndSupportDetails';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep16(): ReactElement {
  return (
    <>
      <RiskAndSupportDetails displayObject={fvsInfoDisplayObject} currentStepNo="step16" />
    </>
  );
}

export default FVSStep16;
